function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fe0000",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h15v10H0V5Z",
    style: {
      fill: "#000095",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,6.25l-1.875,6.998,5.123-5.123-6.998,1.875,6.998,1.875-5.123-5.123,1.875,6.998,1.875-6.998-5.123,5.123,6.998-1.875-6.998-1.875,5.123,5.123-1.875-6.998",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 10,
    r: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,12.125c-1.172,0-2.125-.953-2.125-2.125s.953-2.125,2.125-2.125,2.125.953,2.125,2.125-.953,2.125-2.125,2.125ZM7.5,8.125c-1.034,0-1.875.841-1.875,1.875s.841,1.875,1.875,1.875,1.875-.841,1.875-1.875-.841-1.875-1.875-1.875Z",
    style: {
      fill: "#000095"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/TW.39ba7f4b8db4377563b99ce7112dfa0e.svg";
export { ForwardRef as ReactComponent };